import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/verifications";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getVerification() {
  return request("/verification/", { method: "GET" });
}

export function submitVerification(formData) {
  return requestWithAuth(
    `${API_BASE}/verification/`,
    {
      method: "POST",
      body: formData,
    },
    { fallbackMessage: "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u0633\u0627\u0644 \u0645\u062f\u0627\u0631\u06a9" }
  );
}
